import { createAppConfigFromEnv } from '@/shared/platform';

/**
 * RCM is an independent product. The only outside service it uses is the
 * ELVA account app, for signing in; everything else it needs it asks its own
 * backend for.
 *
 * So `mainApiUrl` is forced empty rather than read from the environment.
 * `getMainApi()` is core-api in every other app, and leaving it pointed
 * there would let a stray call reach Core and look like it worked. Empty
 * means a mistake fails at once, in development, instead of quietly adding a
 * dependency nobody decided on. RCM's own client is `src/api/rcmApi.ts`.
 */
const env = import.meta.env as Record<string, string | undefined>;

export const rcmPlatformConfig = createAppConfigFromEnv(
  { ...env, VITE_MAIN_API_BASE_URL: '' },
  {
    allowEmptyMainApiUrl: true,
    appName: 'Elva RCM',
    tokenKey: 'elva_auth_token',
    loginCallbackPath: '/loginok',
    publicPathPrefix: '/public',
  }
);
